import { Message } from '../message';
import { PREDEFINED_MESSAGES } from './utils/predefined-messages.constants';

import * as S from './predefined-messages.styles';

import type { TPredefinedMessagesConfig } from './predefined-messages.types';

const PredefinedMessages = ({ type, onSelect }: TPredefinedMessagesConfig) => {
	return (
		<S.Container data-qa="predefined-messages">
			{PREDEFINED_MESSAGES[type]?.map(({ message, id }) => (
				<button type="button" key={`${type}-${id}`} data-qa={`predefined-message-${id}`} onClick={() => onSelect({ message, id })}>
					<Message data={{ message }} itsMyMessage renderInfoBlock={false} />
				</button>
			))}
		</S.Container>
	);
};

PredefinedMessages.displayName = 'PredefinedMessages';
export { PredefinedMessages };
